import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { PageableResponse } from '@core/interface/pageable.interface';
import { ListCompanyCollectorCommissionTariffRequestDto } from '@domain/company-collector-commission-tariff/dtos/list-company-collector-commission-tariff-request.dto';
import { GetCompanyCollectorCommissionTariffRequestDto } from '@domain/company-collector-commission-tariff/dtos/get-company-collector-commission-tariff-request.dto';
import { CompanyCollectorCommissionTariffResponseDto } from '@domain/company-collector-commission-tariff/dtos/company-collector-commission-tariff-response.dto';
import { CreateCompanyCollectorCommissionTariffRequestDto } from '@domain/company-collector-commission-tariff/dtos/create-company-collector-commission-tariff-request.dto';
import { UpdateCompanyCollectorCommissionTariffRequestDto } from '@domain/company-collector-commission-tariff/dtos/update-company-collector-commission-tariff-request.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorCommissionTariffService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('company/collector/commission-tariff');
  }

  list(request: ListCompanyCollectorCommissionTariffRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<CompanyCollectorCommissionTariffResponseDto>>
    >(queryUrl, {
      params: { ...request },
    });
  }

  get(request: GetCompanyCollectorCommissionTariffRequestDto) {
    const queryUrl = `${this.getApiUrl()}/get`;
    return this.http.get<
      ApiResponse<CompanyCollectorCommissionTariffResponseDto[]>
    >(queryUrl, {
      params: { ...request } as any,
    });
  }

  create(request: CreateCompanyCollectorCommissionTariffRequestDto) {
    const queryUrl = `${this.getApiUrl()}/`;
    return this.http.post<
      ApiResponse<CompanyCollectorCommissionTariffResponseDto>
    >(queryUrl, request);
  }

  update(
    refId: string,
    request: UpdateCompanyCollectorCommissionTariffRequestDto,
  ) {
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<
      ApiResponse<CompanyCollectorCommissionTariffResponseDto>
    >(queryUrl, request);
  }

  delete(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/${request.refId}`;
    return this.http.delete<
      ApiResponse<CompanyCollectorCommissionTariffResponseDto>
    >(queryUrl);
  }
}
